import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Stack } from "react-bootstrap";
import Textarea from "../../../ui/Textarea";
import SelectFamily from "../../../ui/SelectFamily";
import DatePicker from "../../../ui/DatePicker";
import { User } from "../../../../types/user";
import Input from "../../../ui/Input";
import SelectObject from "../../../ui/SelectObject";

interface InfractionState {
  note?: any;
  activeFamily: User[];
  familyUser: string;
  setFamilyUser: any;
  isBanned?: boolean;
  isDeleted?: boolean;
  isSelectedDisabled?: boolean;
  noteType?: any;
  setUpdatedNote: any;
  setSaveIsEnabled: any;
  setUserToSave: any;
  myCase?: boolean;
  editNote?: boolean;
}

const Infraction = ({
  note,
  activeFamily,
  familyUser,
  setFamilyUser,
  isBanned = false,
  isDeleted = false,
  isSelectedDisabled = false,
  noteType,
  setUpdatedNote,
  setSaveIsEnabled,
  setUserToSave,
  myCase,
  editNote = false,
}: InfractionState) => {
  const mainRef = useRef();
  const [type, setType] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [noteDate, setNoteDate] = useState<string>("");
  const [typeOptions, setTypeOptions] = useState<any[]>([]);

  const handleScroll = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  };

  useEffect(() => {
    handleScroll(mainRef);

    const typeOptions = noteType?.fields?.find((f: any) => (f.key = "type")).options;
    setTypeOptions(typeOptions);

    if (editNote) {
      setNoteDate(note?.fields?.date);
      setType(note?.fields?.type);
      setDescription(note?.fields?.description);
    } else {
      setNoteDate(new Date().toISOString().split("T")[0]);
    }
  }, []);

  useEffect(() => {
    const parts = familyUser.split("|");

    const note = {
      notetype: "infraction",
      subject:
        familyUser !== "unassigned"
          ? {
              id: parts[0],
              type: parts[1],
            }
          : { id: 0 },
      fields: {
        date: noteDate,
        type: type,
        description: description,
      },
    };

    setUpdatedNote(note);
  }, [familyUser, noteDate, type, description, setUpdatedNote]);

  const updateFamilyUser = (e: any) => {
    setFamilyUser(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  const updateType = (e: any) => {
    setType(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  const updateDescription = (e: any) => {
    setDescription(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  const updateDate = () => {
    setSaveIsEnabled(true);
    setUserToSave(true);
  };

  useEffect(() => {
    if (!noteDate) {
      setSaveIsEnabled(false);
      setUserToSave(false);
    }
  }, [noteDate]);

  return (
    <Stack gap={3} className="mt-4">
      <Row ref={mainRef}>
        {isSelectedDisabled || !myCase ? (
          <Col xs={6}>
            <Input
              label="Household Member"
              type="text"
              value={familyUser.split("|")[2]}
              cssInput={isDeleted || isBanned ? "app-danger-text" : ""}
              disabled={true}
            />
          </Col>
        ) : (
          <SelectFamily
            family={activeFamily}
            familyUser={familyUser ? familyUser : "unassigned"}
            updateFamilyUser={updateFamilyUser}
            defaultSelection="Unassigned"
          />
        )}
        <Col className="col-lg-4 col-md-6 col-sm-8">
          <DatePicker
            label="Date"
            currentValue={noteDate}
            setCurrentValue={setNoteDate}
            onUpdate={() => updateDate()}
            required={true}
            hasMaxDate={true}
            disabled={myCase ? false : true}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={6}>
          {typeOptions?.length > 0 ? (
            <SelectObject
              label="Type"
              value={type}
              options={typeOptions}
              onUpdate={(e: any) => updateType(e)}
              disabled={myCase ? false : true}
            />
          ) : (
            <Input label="Type" type="text" value={type} onUpdate={(e: any) => updateType(e)} disabled={myCase ? false : true} />
          )}
        </Col>
      </Row>
      <Row className="mb-5">
        <Col xs={12}>
          <Textarea label="Description" value={description} onUpdate={(e: any) => updateDescription(e)} disabled={myCase ? false : true} />
        </Col>
      </Row>
    </Stack>
  );
};

export default Infraction;
